import React from "react";
import { useNavigate } from "react-router-dom";

import { AiOutlineDownload } from "react-icons/ai";

const Card = ({ data,getGradeCardsOfAStudent }) => {
  const navigate = useNavigate();


  const handleCardClick = () => {
    // Redirect to a dummy route
    //navigate(`/gradeentryform/${data.data}/${session}/${courseCode}`); 
  };

  return (
    <div
      onClick={handleCardClick}
      className={`w-[160px] h-[150px] shadow-lg rounded-2xl p-4 flex flex-col justify-center cursor-pointer hover:shadow-xl transition-shadow duration-300
        ${
          data.resultState.toUpperCase() !== "DECLARED"
            ? "bg-gradient-to-r from-pink-600 to-pink-300 hover:from-pink-600 hover:to-pink-500 text-white"
           
            : "bg-gradient-to-r from-green-400 to-green-100 hover:from-green-400 hover:to-green-400 text-black"
        }`
      }
    >
        <p className="w-full text-center text-xs text-gray-500">SEMESTER</p>
      <p className="w-full text-xl text-center mb-[10px]">{data.semester}</p>      
      <p className="w-full text-center mb-[10px]">
        {(data.resultState || '').toUpperCase() === 'DECLARED' ? 'Declared' : 'Not Declared'}
      </p>       

      {((data.isWithHeld || '').toUpperCase() === 'YES') && (
        <p className="w-full text-center mb-[10px] text-red-700">
          WITHHELD
        </p>  
        )}

      {((data.resultState || '').toUpperCase() === 'DECLARED') &&((data.isWithHeld || '').toUpperCase() === 'NO') && (
        <button 
                             onClick={(e) => getGradeCardsOfAStudent(e,data.semester)} 
                             className="flex text-sm items-center gap-2 bg-orange-600 text-white px-2 py-2 rounded-lg hover:bg-orange-700 transition duration-200"
                           >
                             <AiOutlineDownload size={20} />
                             GradeCard 
                           </button>
        )}
    </div>
  );
};

export default Card;
